export default "__VITE_ASSET__yL9abug9__"